<template>
  <div class="page modal-page-scroll d-flex flex-column">
    <div class="row header-page w-100">
      <div class="col">
        <h3>
          Scenario
          <span v-if="type == 'stressato'">Stress</span>
          <span v-if="type == 'sfavorevole'">Sfavorevole</span>
          <span v-if="type == 'moderato'">Moderato</span>
          <span v-if="type == 'favorevole'">Favorevole</span>
        </h3>
        <div class="row banner-area">
          <div class="col">
            <div class="banner scenario-info">
              <div class="scenario-subtitle">
                Evoluzione del premio versato nel periodo osservato
              </div>
              <div class="scenario-desc">
                Le performance sono basate sulla metodologia prevista dal
                Regolamento Europeo PRIIPs e sono coerenti con quanto esposto
                nel Documento contenente le informazioni chiave (KID)
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row form-data mt-3 w-100">
      <div class="col mt-3">
        <b-tabs pills class="list-tabs" v-if="false">
          <b-tab title="Vista grafico">
            <b-card-text>
              <h4 class="mb-4">Grafico di riepilogo</h4>
              <div class="row">
                <div class="col-4">
                  <div class="d-flex flex-column scenario-dett-box">
                    <div class="scenario-dett-label mb-1">Il tuo capitale</div>
                    <div class="scenario-dett-value">
                      <span v-if="scenario !== null">{{
                        scenario.surrenderValueArr[
                          scenario.surrenderValueArr.length - 1
                        ] | currency
                      }}</span>
                    </div>
                    <div class="scenario-dett-desc">
                      al termine del periodo di simulazione ({{
                        $store.state.yearValue
                      }}
                      anni)
                    </div>
                  </div>
                  <div class="d-flex flex-column scenario-dett-box mt-3">
                    <div class="scenario-dett-label mb-1">
                      Rendimento del contratto
                    </div>
                    <div class="scenario-dett-value">
                      <span v-if="scenario !== null">
                        {{
                          scenario.tirCostLastYearValue
                            | currency({
                              symbol: "%",
                              thousandsSeparator: ".",
                              fractionCount: 2,
                              fractionSeparator: ",",
                              symbolPosition: "",
                              symbolSpacing: true
                            })
                        }}</span
                      >
                    </div>
                    <div class="scenario-dett-desc">
                      al termine del periodo di simulazione ({{
                        $store.state.yearValue
                      }}
                      anni)
                    </div>
                  </div>
                </div>
                <div class="col-8">
                  <div class="table-data">
                    <highcharts :options="chartOptions"></highcharts>
                  </div>
                </div>
              </div>
            </b-card-text>
          </b-tab>
          <b-tab title="Vista tabella" v-if="false">
            <b-card-text>
              <h4 class="mb-4">Tabella di riepilogo</h4>
              <div class="table-data">
                <b-table
                  small
                  :items="scenarios.data"
                  :fields="scenarios.fields"
                >
                  <template v-slot:cell(year)="data">
                    {{ data.value }}
                  </template>
                  <template v-slot:cell()="data">
                    {{ data.value | currency }}
                  </template>
                </b-table>
              </div>
            </b-card-text>
          </b-tab>
        </b-tabs>
        <h4 class="mb-4">Grafico di riepilogo</h4>
        <div class="row">
          <div class="col-4">
            <div class="d-flex flex-column scenario-dett-box">
              <div class="scenario-dett-label mb-1">Il tuo capitale</div>
              <div class="scenario-dett-value">
                <span v-if="scenario !== null">{{
                  scenario.surrenderValueArr[
                    scenario.surrenderValueArr.length - 1
                  ] | currency
                }}</span>
              </div>
              <div class="scenario-dett-desc">
                al termine del periodo di simulazione ({{
                  $store.state.yearValue
                }}
                anni)
              </div>
            </div>
            <div class="d-flex flex-column scenario-dett-box mt-3">
              <div class="scenario-dett-label mb-1">
                Rendimento del contratto
              </div>
              <div class="scenario-dett-value">
                <span v-if="scenario !== null">
                  {{
                    scenario.tirCostLastYearValue
                      | currency({
                        symbol: "%",
                        thousandsSeparator: ".",
                        fractionCount: 2,
                        fractionSeparator: ",",
                        symbolPosition: "",
                        symbolSpacing: true
                      })
                  }}</span
                >
              </div>
              <div class="scenario-dett-desc">
                al termine del periodo di simulazione ({{
                  $store.state.yearValue
                }}
                anni)
              </div>
            </div>
          </div>
          <div class="col-8">
            <div class="table-data">
              <highcharts :options="chartOptions"></highcharts>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row w-100">
      <div class="col mt-3">
        <div class="scenario-desc mb-3">
          <span v-if="type == 'stressato'">
            I calcoli si basano sui rendimenti storici degli investimenti
            sottostanti il prodotto, e in particolare:
            <ul>
              <li>
                per la gestione separata, vengono simulati 10.000 rendimenti
                futuri sulla base dell’ asset allocation osservata e delle serie
                storiche osservate negli ultimi 5 anni per le principali
                categorie di attivi (azionario, obbligazionario, valute,
                immobiliare, ecc.), andando a considerare i quattro mesi più
                volatili in modo da “stressare” le proiezioni ottenute;
              </li>
              <li>
                per i fondi interni, i rendimenti futuri vengono proiettati con
                metodologia analoga in base alle osservazioni storiche di
                ciascun fondo degli ultimi 5 anni, andando anche qui a
                considerare i quattro mesi più volatili in modo da “stressare”
                le proiezioni ottenute.
              </li>
            </ul>
            Da questi calcoli ne risultano numerosi scenari, ognuno dei quali è
            composto da una serie di rendimenti annui, per ciascun anno
            dell’orizzonte temporale dell’investimento. Tra questi, lo scenario
            di stress è quello che si colloca in 9500° posizione (su 10.000
            scenari), una volta ordinati tutti i risultati simulati dal migliore
            al peggiore.
            <br />Per fare un esempio, in una gara di 100 atleti, lo scenario di
            stress rappresenterebbe il tempo del 95° classificato in una gara in
            condizioni avverse
          </span>
          <span v-if="type == 'sfavorevole'">
            I calcoli si basano sui rendimenti storici degli investimenti
            sottostanti il prodotto, e in particolare:
            <ul>
              <li>
                per la gestione separata, vengono simulati 10.000 rendimenti
                futuri sulla base dell’asset allocation osservata e delle serie
                storiche degli ultimi 5 anni per le principali categorie di
                attivi (azionario, obbligazionario, valute, immobiliare, ecc.)
              </li>
              <li>
                per i fondi interni, i rendimenti futuri vengono proiettati con
                metodologia analoga in base alle osservazioni storiche di
                ciascun fondo degli ultimi 5 anni.
              </li>
            </ul>
            Da questi calcoli ne risultano numerosi scenari, ognuno dei quali è
            composto da una serie di rendimenti annui, per ciascun anno
            dell’orizzonte temporale dell’investimento. Tra questi, lo scenario
            sfavorevole è quello che si colloca in 9000° posizione (su 10.000
            scenari), una volta ordinati tutti i risultati simulati dal migliore
            al peggiore.
            <br />Per fare un esempio, in una gara di 100 atleti, lo scenario
            sfavorevole rappresenterebbe il tempo del 90° classificato in una
            gara in condizioni normali
          </span>
          <span v-if="type == 'moderato'">
            I calcoli si basano sui rendimenti storici degli investimenti
            sottostanti il prodotto, e in particolare:
            <ul>
              <li>
                per la gestione separata, vengono simulati 10.000 rendimenti
                futuri sulla base dell’asset allocation osservata e delle serie
                storiche degli ultimi 5 anni per le principali categorie di
                attivi (azionario, obbligazionario, valute, immobiliare, ecc.)
              </li>
              <li>
                per i fondi interni, i rendimenti futuri vengono proiettati con
                metodologia analoga in base alle osservazioni storiche di
                ciascun fondo degli ultimi 5 anni.
              </li>
            </ul>
            Da questi calcoli ne risultano numerosi scenari, ognuno dei quali è
            composto da una serie di rendimenti annui, per ciascun anno
            dell’orizzonte temporale dell’investimento. Tra questi, lo scenario
            moderato è quello che si colloca in 5000° posizione (su 10.000
            scenari), una volta ordinati tutti i risultati simulati dal migliore
            al peggiore.
            <br />Per fare un esempio, in una gara di 100 atleti, lo scenario
            moderato rappresenterebbe il tempo del 50° classificato in una gara
            in condizioni normali
          </span>
          <span v-if="type == 'favorevole'">
            I calcoli si basano sui rendimenti storici degli investimenti
            sottostanti il prodotto, e in particolare:
            <ul>
              <li>
                per la gestione separata, vengono simulati 10.000 rendimenti
                futuri sulla base dell’asset allocation osservata e delle serie
                storiche degli ultimi 5 anni per le principali categorie di
                attivi (azionario, obbligazionario, valute, immobiliare, ecc.).
              </li>
              <li>
                per i fondi interni, i rendimenti futuri vengono proiettati con
                metodologia analoga in base alle osservazioni storiche di
                ciascun fondo degli ultimi 5 anni.
              </li>
            </ul>
            Da questi calcoli ne risultano numerosi scenari, ognuno dei quali è
            composto da una serie di rendimenti annui, per ciascun anno
            dell’orizzonte temporale dell’investimento. Tra questi, lo scenario
            favorevole è quello che si colloca in 1000° posizione (su 10.000
            scenari), una volta ordinati tutti i risultati simulati dal migliore
            al peggiore.
            <br />Per fare un esempio, in una gara di 100 atleti, lo scenario
            favorevole rappresenterebbe il tempo del 10° classificato in una
            gara in condizioni normali
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ColumnLineChartDataYears } from "../../data/column-line-chart-data.years";
import { ScenarioDetailData } from "../../data/scenario-detail.data";
import {
  formatDecimal,
  formatInt,
  replaceDotWithComma
} from "../../utils/generic.utils";
export default {
  name: "ScenarioDett",
  props: {
    type: String
  },
  data: () => {
    return {
      val: false,
      modal: false,
      scenario: null,
      currentYearValues: {},
      scenarios: {},
      chartOptions: {},
      window: {
        width: 0,
        height: 0
      }
    };
  },
  created: function() {
    this.scenarios = JSON.parse(JSON.stringify(ScenarioDetailData));

    this.scenario = this.$store.state.scenarios.filter(
      s => s.type === this.type
    )[0];

    this.scenario.finalPerformanceArr = this.scenario.finalPerformanceArr.slice(
      0,
      this.$store.state.yearValue
    );
    this.scenario.deathTotalArr = this.scenario.deathTotalArr.slice(
      0,
      this.$store.state.yearValue
    );
    this.scenario.surrenderValueArr = this.scenario.surrenderValueArr.slice(
      0,
      this.$store.state.yearValue
    );
    this.scenarios.data = [];
    for (let i = 0; i < this.scenario.finalPerformanceArr.length; i++) {
      this.scenarios.data.push({
        year: i + 1,
        contracValue: Number(this.scenario.finalPerformanceArr[i]).toFixed(2),
        deadValue: Number(this.scenario.deathTotalArr[i]).toFixed(2),
        rescureValue: Number(this.scenario.surrenderValueArr[i]).toFixed(2)
      });
    }

    // add data in chart
    this.chartOptions = JSON.parse(JSON.stringify(ColumnLineChartDataYears));
    this.chartOptions.xAxis[0].categories = [];
    this.chartOptions.series[0].data = [];
    this.chartOptions.series[1].data = [];

    const extraProtectionTooltip =
      "<tr >" +
      '<td style="padding:2px">Capitale in caso di: </td>' +
      '<td style="padding:2px"></td>' +
      "</tr>" +
      "<tr>" +
      '<td style="padding:2px 2px 2px 20px">decesso</td>' +
      '<td style="padding:2px"><b>&euro; {point.deathValue}</b></td>' +
      "</tr>" +
      "<tr>" +
      '<td style="padding:2px 2px 2px 20px">decesso da infortunio</td>' +
      '<td style="padding:2px"><b>&euro; {point.deathIncidentCapital}</b></td>' +
      "</tr>" +
      "<tr>" +
      '<td style="padding:2px 2px 2px 20px">decesso da incidente stradale</td>' +
      '<td style="padding:2px"><b>&euro; {point.deathTrafficAccidentCapital}</b></td>' +
      "</tr>";

    const noExtraProtectionTooltip =
      "<tr>" +
      '<td style="padding:2px">Capitale in caso di decesso: </td>' +
      '<td style="padding:2px"><b>&euro; {point.deathValue}</b></td>' +
      "</tr>";

    // ----
    this.chartOptions.tooltip = {
      headerFormat:
        '<span style="font-size:10px">Anno {point.key}</span><table>',
      pointFormat:
        '<tr><td style="padding:2px">{series.name}: </td>' +
        '<td style="padding:2px"><b>&euro; {point.surrenderCapital}</b></td></tr>' +
        "<tr >" +
        '<td style="padding:2px">Premio versato: </td>' +
        '<td style="padding:2px"><b>&euro; {point.capitalValue}</b></td>' +
        "</tr>" +
        "</tr>" +
        "<tr >" +
        '<td style="padding:2px">Valore del contratto: </td>' +
        '<td style="padding:2px"><b>&euro; {point.finalPerformanceValue}</b></td>' +
        "</tr>" +
        (this.$store.state.extraProtectionValue.length > 0
          ? extraProtectionTooltip
          : noExtraProtectionTooltip),
      footerFormat: "</table>",
      shared: true,
      useHTML: true
    };

    this.scenario.surrenderValueArr.forEach((val, index) => {
      // this.chartOptions.series[0].data.push(Math.round(val * 100) / 100);
      this.chartOptions.series[0].data.push({
        y: Math.round(val * 100) / 100,
        surrenderCapital: formatInt(Math.round(val * 100) / 100),
        deathIncidentCapital: formatInt(
          Number(this.scenario.deathTotalArr[index].toFixed(2)) +
            Number(this.scenario.ACMAExtraProtectionValuieArr[index].toFixed(2))
        ),
        deathTrafficAccidentCapital: formatInt(
          Number(this.scenario.deathTotalArr[index].toFixed(2)) +
            2 *
              Number(
                this.scenario.ACMAExtraProtectionValuieArr[index].toFixed(2)
              )
        ),
        deathValue: formatInt(
          Number(this.scenario.deathTotalArr[index].toFixed(2))
        ),
        tirCostLastYearValue: formatDecimal(this.scenario.tirCostLastYearValue),
        finalPerformanceValue: formatInt(
          Number(this.scenario.finalPerformanceArr[index].toFixed(2))
        ),
        capitalValue: formatInt(this.$store.state.capitalValue)
      });

      this.chartOptions.series[1].data.push(
        Math.round(this.$store.state.capitalValue * 100) / 100
      );
      this.chartOptions.xAxis[0].categories.push(index + 1);
    });
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    showModal() {
      this.modal = true;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    }
  },
  filters: {
    numberFilter(value) {
      return replaceDotWithComma(value);
    }
  }
};
</script>
